import { Communication } from './communication';
import { Qualification } from './qualification';
import { languageI } from './secretary';
import { Specialty } from './specialty';

export interface profileQualificationI {
  qualifications: Qualification[];
  courses: Qualification[];
  languages?: languageI[];
  communication: Communication[];
}

export interface profileSpecialtiesI {
  specialties: Specialty[];
}

export interface tabI {
  title: string;
  id: number;
  type?: string;
  content?: any[];
}

export interface personI {
  name: string;
  id: number;
}

export interface requiredI {
  [key: string]: any;
}

export interface paginationI {
  total: number;
  limit: number;
  pages: number;
  page: number;
}

export const paginationInitialState: paginationI = {
  total: 0,
  limit: 25,
  pages: 1,
  page: 1,
};
